import { Injectable } from "@angular/core";

import { Period } from "@helper/abstraction/user";

@Injectable({
	providedIn: "root"
})
export class TodayService {
	public defaultPeriod: Period = "MONTH";

	public set period(data: Period) {
		this.defaultPeriod = data;
	}

	public get oneMonth(): [Date, Date] {
		return this.setDefaultPeriod(this.defaultPeriod);
	}

	public get todayRange(): [Date, Date] {
		const today = new Date();
		return [
			new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0),
			new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59),
		];
	}

	public get currentMonth(): [Date, Date] {
		const today = new Date();
		return [
			new Date(today.getFullYear(), today.getMonth(), 1, 0, 0, 0, 0),
			new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59),
		];
	}

	public get onlyOneMonth(): [Date, Date] {
		return this.setDefaultPeriod("MONTH");
	}

	private setDefaultPeriod(defaultPeriod: string): [Date, Date] {
		const today = new Date();
		let dateStart: Date;
		let dateEnd: Date;
		switch (defaultPeriod) {
			case "DAY":
				dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0);
				dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59);
				break;
			case "WEEK":
				dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 6, 0, 0, 0, 0);
				dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59);
				break;
			case "MONTH":
			default:
				dateStart = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate(), 0, 0, 0, 0);
				dateEnd = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 59);
				break;
		}
		return [dateStart!, dateEnd!];
	}
}
